export default {
    "error_422": "Please fill in all the fields",
    "trashed_failed": "Cannot be deleted!",
    "trashed_success": "successfully deleted!",
    "api_timeout": "API does not respond, try again later!",
    "please_wait": "Please wait...",
    "long_operation": "Operation is taking a long time, please wait...",
}
